import { type ComponentStyleConfig } from '@chakra-ui/react';

export const Badge: ComponentStyleConfig = {
  baseStyle: {
    userSelect: 'none',
  },
  variants: {
    success: {
      bg: 'success.500',
      color: 'neutral.1000',
      _dark: {
        bg: 'success.900',
      },
    },
    error: {
      bg: 'danger.900',
      color: 'neutral.50',
      _dark: {
        bg: 'danger.950',
      },
    },
  },
};
